/**
 *
 * @returns {string}
 */
NLMK.uuidv4 = function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);

        return v.toString(16);
    });
};


/**
 *
 * @param {string} str phone number
 */
NLMK.cleanPhone = function cleanPhone(str) {
    return ((str || '').toString().match(/[+\d]/gi) || []).join('');
};

/**
 *
 * @returns {boolean}
 */
NLMK.isMobileWidth = function isMobile() { return innerWidth < NLMK.mediaQueries.verticalTablet.min };

/**
 *
 * @returns {boolean}
 */
NLMK.isVerticalTabletWidth = function isVerticalTablet() { return innerWidth >= NLMK.mediaQueries.verticalTablet.min && innerWidth <= NLMK.mediaQueries.verticalTablet.max };

/**
 *
 * @returns {boolean}
 */
NLMK.isHorizontalTabletWidth = function isHorizontalTabletWidth() { return innerWidth >= NLMK.mediaQueries.horizontalTablet.min && innerWidth <= NLMK.mediaQueries.horizontalTablet.max };

/**
 *
 * @returns {boolean}
 */
NLMK.isDesktopWidth = function isDesktopWidth() { return innerWidth >= NLMK.mediaQueries.desktop.min };

/**
 * @returns {undefined}
 */
NLMK.trimTextToRelativeBlock = function trimTextToRelativeBlock($textBlock, $relativeBlock, textEndPlaceholder = ' ...')
{
    if (!$textBlock.data('original-text')) {
        $textBlock.data('original-text', $textBlock.text());
    } else {
        $textBlock.text($textBlock.data('original-text'));
    }

    $textBlock.text($textBlock.text().trim());

    do {
        if ($textBlock.height() <= $relativeBlock.height()) {
            return;
        }

        let currentText = $textBlock.text();

        // убрать плейсхолдер если он указан и был добавлен
        if (textEndPlaceholder.length && textEndPlaceholder === currentText.substr(textEndPlaceholder.length * -1)) {
            currentText = currentText.substring(0, currentText.length - textEndPlaceholder.length);
        }

        currentText = currentText.substring(0, currentText.lastIndexOf(' ')) + textEndPlaceholder;

        $textBlock.text(currentText);
    } while ($textBlock.text().length > textEndPlaceholder.length);
}



// WEBPACK FOOTER //
// ./js/main/package/utils.js